// src/api/kpsCalendar.js
// Заглушки API для 6-го раздела KPS Calendar. Замените на реальные вызовы бекенда.

import { http, setActiveDate } from './http';
import { checkOrCreateBookByDate } from './book';
import { listResults, createResult, updateResult, deleteResult } from './results'

// Получить записи раздела 6 (Результаты охраны ГГ и др. сведения) за дату
export async function getSection6Entries(date) {
  let dateISO = normalizeDate(date);
  if (dateISO) {
    setActiveDate(dateISO);
    // ensure book context (создаст/получит book)
    await checkOrCreateBookByDate(dateISO);
  }
  const list = await listResults({});
  return Array.isArray(list) ? list : [];
}

// Создать/обновить запись раздела 6
export async function saveSection6Entry(date, entry) {
  let dateISO = normalizeDate(date);
  if (dateISO) {
    setActiveDate(dateISO);
    await checkOrCreateBookByDate(dateISO);
  }
  const payload = {
    // нормализация (check_type_id, check_time, border_patrol_type) выполнится в results.js
    check_type_id: entry.checkTypeId ?? entry.checkType ?? entry.check_type_id ?? entry.check_type ?? null,
    time: entry.time ?? null, // HH:MM — results.js соберёт check_time с датой
    square: entry.square ?? null,
    border_patrol_type: entry.patrolType ?? entry.border_patrol_type ?? entry.patrol_type ?? null,
    text: entry.text ?? '',
  };
  if (entry.id) {
    return await updateResult(entry.id, payload, { dateISO });
  } else {
    return await createResult(payload, { dateISO });
  }
}

// Удалить запись раздела 6
export async function deleteSection6Entry(date, id) {
  let dateISO = normalizeDate(date);
  if (dateISO) {
    setActiveDate(dateISO);
    await checkOrCreateBookByDate(dateISO);
  }
  return await deleteResult(id);
}

function normalizeDate(d) {
  if (!d) return null;
  if (d instanceof Date) return d.toISOString().slice(0, 10);
  if (typeof d === 'string') {
    const s = d.trim();
    return /^\d{4}-\d{2}-\d{2}$/.test(s) ? s : null;
  }
  return null;
}

